/// <amd-module name="Reporting/BoardsCommon/AccessDeniedMessage" />
import * as React from "react";
import * as Resources from "Reporting/BoardsCommon/Resources";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { VssComponent } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { ZeroData } from "VSSUI/ZeroData";

/** Common abstraction for Errors on Report Pages. */
export class AccessDeniedMessage extends VssComponent {
    private linkUrl = "https://go.microsoft.com/fwlink/?LinkId=786441";
    public render(): JSX.Element {
        return (
            <ZeroData
                primaryText={Resources.AccessDeniedSummary}
                secondaryText={
                    <FormatComponent format={Resources.AccessDeniedDetail}>
                        <a href={this.linkUrl}>{Resources.AccessDeniedLinkText}</a>
                    </FormatComponent>
                }
                imageAltText={Resources.NoPermissionImageDescription}
                imagePath={getAssetLocation(
                    this.context.pageContext,
                    "ms.vss-reporting-web/boards-reporting-common-content/images/no-permission.svg"
                )}
            />
        );
    }
}
